<template>
    <!-- 老师评价模块 -->
    <div class="teach-box">
        <div :class="['title', isEn ? 'title-en' : '']">
            老师评价
        </div>
        <div class="play-box">
            <img class="head-img" :src="teacherImage" alt="" srcset="">
            <div class="audio" @click="handlePlay">
                <img
                    class="laba"
                    :src="isPlaying ? 'https://i.gsxcdn.com/2713926755_1vhi2jnm.png' : 'https://i.gsxcdn.com/2713160132_pu1ivz67.png'"
                    alt=""
                    srcset=""
                >
                <div class="time">
                    {{duration}}″
                </div>
            </div>
            <div :style="{opacity: showContinuePlayBtn ? '1' : '0'}" class="play-state" @click="continuePlay">
                继续播放
            </div>
        </div>
        <div class="evaluate">
            <span v-if="showTranslateText" class="translate">翻译：</span>{{teacherEvaluateTxt}}
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        isEn: {
            type: Boolean,
            default() {
                return false;
            }
        },
        showModele: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    watch: {
        showModele(val) {
            if (val) {
                this.isPlaying = false;
                this.showContinuePlayBtn = false;
            } else {
                this.audioEl?.pause();
            }
        }
    },
    created() {
        const {teacherEvaluateInfo: {teacherImage, teacherEvaluateTxt, teacherEvaluateUrl, showTranslateText = false}} = this.pageData;
        this.teacherImage = teacherImage;
        this.teacherEvaluateTxt = teacherEvaluateTxt;
        this.teacherEvaluateUrl = teacherEvaluateUrl;
        this.showTranslateText = showTranslateText;
        this.playAudio(teacherEvaluateUrl);
    }
})
export default class TeachPromot extends Vue {
    teacherImage = '';
    teacherEvaluateTxt = '';
    teacherEvaluateUrl = '';
    showTranslateText = false;
    duration = 0;
    showContinuePlayBtn = false;
    isPlaying = false;
    audioEl = null;

    // 点击播放/暂停音频
    handlePlay() {
        if (this.audioEl) {
            if (this.audioEl.paused) {
                this.$emit('eventBus', 'lspj');
                this.pauseAudio();
                console.log('开始播放音频');
                this.showContinuePlayBtn = false;
                this.audioEl.currentTime = 0;
                this.isPlaying = true;
                this.audioEl.play();
            } else {
                console.log('暂停播放音频');
                this.showContinuePlayBtn = true;
                this.isPlaying = false;
                this.audioEl.pause();
            }
        } else {
            this.$emit('eventBus', 'lspj');
            this.pauseAudio();
            this.audioEl.play();
        }
    }
    // 继续播放音频
    continuePlay() {
        this.showContinuePlayBtn = false;
        this.isPlaying = true;
        this.$emit('eventBus', 'lspj');
        this.pauseAudio();
        this.audioEl && this.audioEl.play();
    }
    // 暂停其他声音
    pauseAudio() {
        // 捕获是否有正在播放的视频，有的话全部停掉
        const allVideos = document.querySelectorAll('.oss-work-video');
        const arr = [...allVideos];
        arr.forEach(item => {
            item.pause();
        });
    }
    resetAll() {
        this.audioEl && this.audioEl.pause();
        this.isPlaying = false;
    }
    // 播放语音
    playAudio(url) {
        // 播放语音
        return new Promise(resolve => {
            if (!url) {
                resolve();
            }
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onabort',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onwaiting',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.addEventListener('loadedmetadata', () => {
                // 获取音频总时长，单位为秒
                let duration = this.audioEl.duration || 0;
                this.duration = Math.floor(duration);
                console.log('音频时长为: ' + this.duration + ' 秒');
            });
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                resolve();
                this.isPlaying = false;
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                // resolve();
            };
            this.audioEl.onerror = error => {
                console.log(
                    JSON.stringify({
                        content: 'playAudio onerror',
                        audioUrl: url,
                        error: this.audioEl.error?.message,
                    })
                );
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                resolve(error);
            };
        });
    }
}
</script>

<style lang="scss" scoped>
// 老师评价
.teach-box {
    margin-top: .8rem;
    width: 9.15rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0 .05rem .21rem 0 rgba(229, 228, 228, .4);
    border-radius: .43rem;
    display: flex;
    flex-direction: column;
    padding: 0 .64rem .85rem;

    .title {
        margin: -.25rem auto .64rem auto;
        display: flex;
        padding-top: .345rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://i.gsxcdn.com/2713148460_bp1opt2e.png') 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .title-en {
        background: url('https://i.gsxcdn.com/2725359897_t1e029yp.png') 0 no-repeat;
        background-size: cover;
    }

    .play-box {
        display: flex;
        align-items: center;
        margin-bottom: .43rem;

        .head-img {
            width: 1.07rem;
            height: 1.07rem;
            border-radius: 50%;
        }

        .audio {
            margin: 0 .43rem 0 .21rem;
            width: 4.32rem;
            height: 1.07rem;
            background: url(https://i.gsxcdn.com/2713161604_3dif7jfv.png) 0 0 no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;

            .laba {
                width: .35rem;
                height: .43rem;
                border-radius: 50%;
                margin: 0 .19rem 0 .51rem;
            }

            .time {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: .4rem;
                color: #0B0B0B;
                text-align: left;
                font-style: normal;
            }
        }

        .play-state {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: .37rem;
            color: #FC980F;
            text-align: left;
            font-style: normal;
        }
    }

    .evaluate {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: .4rem;
        color: #0B0B0B;
        line-height: 0.56rem;
        text-align: left;
        font-style: normal;

        .translate {
            background: #daf6db;
            border-radius: 0.13rem;
            margin-left: -0.08rem;
            margin-right: 0.12rem;
            padding-left: 0.08rem;
            display: inline-block;
            vertical-align: middle;
            margin-top: -0.15rem;
        }
    }
}
</style>